import { Helper } from '@/methods/base';
import { GetHelper } from '@/methods/get';
import { PostHelper } from '@/methods/post';
import Store from '@/store';
// import { MethodsType, GetSchema } from '@/define';
// 生成ts的schema
export const handleRenderApiTsFileFeature = (apis: GetHelper[] | PostHelper[]): any => {
  const init: any = {
    title: 'Api',
    type: 'object',
    properties: {},
    definitions: {},
    additionalProperties: false,
    preDefine: '',
  };

  return apis.reduce((pre, next) => {
    try {
      [next.generatorDefineParams()].forEach((item) => {
        const { propertiesKey, definitionsKey, key } = item;
        if (!key) {
          return;
        }
        pre['properties'][key] = propertiesKey;
        pre['definitions'][key] = definitionsKey;
      });
      // get是没有data的 post的情况下 存在实例全局对象里面在下面的函数一起处理
      next.generatorDefineData();

      next.generatorDefineResponse().forEach((item) => {
        const { propertiesKey, definitionsKey, key } = item;
        if (!key) {
          return;
        }
        pre['properties'][key] = propertiesKey;
        pre['definitions'][key] = definitionsKey;
      });
    } catch (err) {
      next.debugPrint(next.description, '【handleRenderApiTsFileFeature】' + (err as Error).toString());
    }

    return pre;
  }, init);
};

// 返回接口定义名字的import列表
export const wrapperPreFixDefineName = (helpers: Helper[]): string[] => {
  return helpers.reduce((pre, next) => {
    const params = next.getMethodPreDefineParams();
    if (params) {
      pre.push(params);
    }
    const data = next.renderGetMethodDefineData();
    if (data) {
      pre.push(data);
    }
    const response = next.getMethodsDefineResponse();
    if (response) {
      pre.push(response);
    }
    return pre;
  }, [] as string[]);
};

// 返回接口泛型参数
export const wrapperMethodPreInterface = (helpers: Helper): string[] => {
  const p: string[] = [];
  const params = helpers.getMethodPreDefineParams();
  if (params) {
    p.push(`P extends ${params}`);
  }
  const data = helpers.renderGetMethodDefineData();
  if (data) {
    p.push(`D extends ${data}`);
  }
  const response = helpers.getMethodsDefineResponse();
  if (response) {
    p.push(`S = AxiosResponse < ${response} > `);
  }
  return p;
};

export const wrapperPreImportDefine = (defines: string) => {
  return `
    import { \n${defines}\n
      } from './${Store.filename}.define';
      `;
};

// 兼容旧的拼写（保留向后兼容性）
export const wapperPreFixDefineName = wrapperPreFixDefineName;
export const wapperMethodPreInteface = wrapperMethodPreInterface;
export const wapperPreImportDefine = wrapperPreImportDefine;
